/**
 * Created by zad on 17/4/26.
 */
import { all } from 'redux-saga/effects';
import {
  watchChangeLocale,
  watchChangeReadMode,
  watchChangeFontType,
} from './GlobalSaga';
import {
  watchGetUser,
  watchGetUserOtpChannel,
  watchChangeEditorType,
  watchSwitchScrollAsync,
} from './UserSaga';
import {
  watchGetNotebooks,
  watchSortNotebooks,
  watchNewNoteBook,
  watchDelNoteBookSoft,
  watchRenameNoteBook,
} from './NotebooksSaga';
import {
  watchGetNotes,
  watchSortNotes,
  watchNewNote,
  watchPublishNote,
  watchUpdateNote,
  watchPrivateNote,
  watchDeleteNoteSoft,
  watchMoveNote,
  watchPublishPaidNote,
  watchGetCoverImg,
  watchPostCoverImg,
  watchPostSetNoteTop,
  watchPostUnsetNoteTop,
  watchSetNoteReprintAble,
  watchSetNotePublishTime,
} from './NotesSaga';
import {
  watchGetNoteContent,
  watchPutAudioMessageAsync,
  watchDeleteAudio,
  watchGetAudioUrl,
} from './NoteContentSaga';
import {
  watchRestoreNoteHistoryContent,
  watchGetNoteHistoryContent,
  watchGetNoteHistoryList,
} from './NoteHistorySaga';
import {
  watchGetTrashNotesList,
  watchGetTrashNote,
  watchDelTrashNote,
  watchRecoveryTrashNote,
} from './TrashSaga';


export default function* rootSaga() {
  yield all([
    // global
    watchChangeLocale(),
    watchChangeReadMode(),
    watchChangeFontType(),
    // user
    watchGetUser(),
    watchGetUserOtpChannel(),
    watchChangeEditorType(),
    watchSwitchScrollAsync(),
    // notebooks
    watchGetNotebooks(),
    watchSortNotebooks(),
    watchNewNoteBook(),
    watchDelNoteBookSoft(),
    watchRenameNoteBook(),
    // notes
    watchGetNotes(),
    watchSortNotes(),
    watchNewNote(),
    watchPublishNote(),
    watchUpdateNote(),
    watchPrivateNote(),
    watchDeleteNoteSoft(),
    watchMoveNote(),
    watchPublishPaidNote(),
    watchGetCoverImg(),
    watchPostCoverImg(),
    watchPostSetNoteTop(),
    watchPostUnsetNoteTop(),
    watchSetNoteReprintAble(),
    watchSetNotePublishTime(),
    // note-content
    watchGetNoteContent(),
    watchPutAudioMessageAsync(),
    watchDeleteAudio(),
    watchGetAudioUrl(),
    // note-histtory
    watchGetNoteHistoryList(),
    watchGetNoteHistoryContent(),
    watchRestoreNoteHistoryContent(),
    // trash
    watchGetTrashNotesList(),
    watchGetTrashNote(),
    watchDelTrashNote(),
    watchRecoveryTrashNote(),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/rootSaga.js